<template>
    <div
         :style="`
         text-align:${d.textAlign};
         padding-top:${d.padding}px;
         padding-bottom:${d.padding}px;
         width:100%;
         background-color:rgba(
             ${d.backgroundcolor.r},
             ${d.backgroundcolor.g},
             ${d.backgroundcolor.b},
             ${d.backgroundcolor.a});`">
        <img :src="org.info.small_logo" height="100" />
    </div>
</template>

<script>
  import{
    mapState
  } from 'vuex'
  export default {
    props:['d','active'],
    components: {},
    name: "Header",
    data() {
      return {}
    },
    computed:{
      ...mapState(['icons','org'])
    }
  }
</script>

<style scoped>

</style>